<template>
  <div>
    <el-dialog
      title="订单回访"
      :visible.sync="dialogVisit"
      :modal="false"
      width="600px"
      top="25vh"
      @close="close"
      v-loading="loading">
      <div>
        <el-form ref="form" :model="entity" label-width="80px">
          <el-form-item label="订单编号">
            <el-input disabled v-model="entity.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="回访时间">
            <el-date-picker
              v-model="entity.visitTime"
              type="datetime"
              placeholder="选择回访时间"
              align="right"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="回 访 人" prop="leaderId">
            <el-select
              v-model="entity.visitId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入员工姓名搜索"
              :remote-method="employeeMethod"
              :loading="employeeLoading"
              @change="employeeChange">
              <el-option
                v-for="item in employees"
                :key="item.employeeId"
                :label="item.name"
                :value="item.employeeId"
                style="width: 300px;">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.deptName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回访结果">
            <el-input type="textarea" v-model="entity.visitContent"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {employee, order} from '@/api'
import {today, yesterday} from '@/utils/constant'

export default {
  name: 'OrderAllVisit',
  props: {
    dialogVisit: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object
    }
  },
  created () {
    this.getEmployeeAll('')
  },
  data () {
    return {
      loading: false,
      orgCode: this.$store.state.user.orgCode,
      employees: [],
      employeeAll: [],
      employeeLoading: false,
      dynamicTags: [],
      entities: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    employeeChange (value) {
      let orderForm = this.employees.find((elem) => {
        return elem.employeeId === value
      })
      this.entity['visitName'] = orderForm.name
    },
    async getEmployeeAll (value) {
      this.employeeLoading = true
      let {data} = await employee.getEmployeeList({
        orgCode: this.$store.state.user.orgCode,
        name: value
      })
      this.employeeLoading = false
      if (this.employeeAll.length === 0) this.employeeAll = data
      this.employees = data
      return data
    },
    employeeMethod (query) {
      if (query !== '') {
        this.employeeLoading = true
        this.getEmployeeAll(query)
      } else {
        this.employees = this.employeeAll
      }
    },
    async submit () {
      console.log(this.entity)
      this.loading = true
      let {code} = await order.updateOrderFromBasic({
        orderFormId: this.entity.orderFormId,
        visitTime: this.entity.visitTime,
        visitId: this.entity.visitId,
        visitContent: this.entity.visitContent,
        visit: this.entity.visit,
        visitName: this.entity.visitName,
        visitFlag: true
      })
      this.loading = false
      this.close(true)
      if (code === 0) {
        this.$message({
          message: '回访成功！',
          type: 'success'
        })
      } else {
        this.$message('网络错误，请稍后重试！')
      }
    },
    close (flush) {
      this.entities = {}
      this.$emit('dialogVisit', false)
      if (flush) this.$emit('flush')
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    width: 70%
  }
  .el-input {
    width: 320px;
  }
  .el-date-editor {
    width: 320px !important;
  }
  .el-select {
    width: 320px;
  }
  .el-textarea {
    width: 320px;
  }
</style>
